function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import createTheme from '../create_theme';
var defaults = {
  density: 'standard',
  mode: 'light',
  shape: 'round'
};
var ThemeContext = /*#__PURE__*/React.createContext(_extends({}, defaults, {
  theme: createTheme(defaults)
}));
export default ThemeContext;